import { ColumnEditValue, FileEditValue } from '@components/table/types';

import { AttributeFieldType } from 'api/attributes/requests';

export const appendAttributeValueToFormData = ({
  formData,
  key,
  attributeType,
  value,
}: {
  formData: FormData;
  key: string;
  attributeType: AttributeFieldType;
  value: ColumnEditValue;
}): void => {
  if (attributeType === 'multi_select') {
    formData.append(key, JSON.stringify(value));
    return;
  }

  if (attributeType === 'file') {
    const fileValue = value as FileEditValue;
    if (fileValue.addedFiles[0]) {
      formData.append(key, fileValue.addedFiles[0]);
    } else if (fileValue.removedFileShortIds.length > 0) {
      formData.append(`${key}__remove`, '');
    }
    return;
  }

  if (attributeType === 'file_multi') {
    const fileValue = value as FileEditValue;
    fileValue.addedFiles.forEach((file, index) => {
      formData.append(`${key}__${index}`, file);
    });
    fileValue.removedFileShortIds.forEach((shortId) => {
      formData.append(`${key}__remove__${shortId}`, shortId);
    });
    return;
  }

  formData.append(key, value as string);
};
